var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-radio-group",
    {
      attrs: {
        size: _vm.size,
        disabled: _vm.isDisabled,
        min: _vm.min,
        max: _vm.max,
        "text-color": _vm.textColor,
        fill: _vm.fill
      },
      on: { change: _vm.onChange },
      model: {
        value: _vm.model,
        callback: function($$v) {
          _vm.model = $$v
        },
        expression: "model"
      }
    },
    _vm._l(_vm.radioOptions, function(item) {
      return _c(
        _vm.button ? "el-radio-button" : "el-radio",
        {
          key: item[_vm.itemKey],
          tag: "component",
          class: _vm.customClass,
          attrs: {
            label: item[_vm.itemKey],
            border: _vm.border,
            disabled: item.disabled
          }
        },
        [_vm._v("\n    " + _vm._s(item[_vm.itemLabel]) + "\n  ")]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14f86815", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14f86815","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/core/ui/SasRadioGroup.vue
// module id = null
// module chunks = 